import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import isInteger from 'lodash/isInteger';
import { Button, TextField } from '@one-thd/sui-atomic-components';
import { ZipCodeInputWrapper } from './styles';

const ZipCodeInput = ({
  zipcode,
  onUpdateCallback,
  onZipcodeChange,
}) => {

  const [btnIsEnabled, setBtnIsEnabled] = useState(false);

  useEffect(() => {
    const isZip = zipcode.length === 5 && isInteger(+zipcode);
    setBtnIsEnabled(isZip);
  }, [zipcode]);

  const isZipcode = (newZip) => (isInteger(+newZip) ? newZip : zipcode);

  return (
    <ZipCodeInputWrapper>
      <TextField
        type="tel"
        label="ZIP Code"
        onChange={(evt) => onZipcodeChange(isZipcode(evt.target.value, zipcode))}
        onKeyPress={(evt) => {
          if (evt.key === 'Enter') { onUpdateCallback(evt.target.value); }
        }}
        value={zipcode}
        maxLength="5"
        placeholder="Zip Code"
      />
      <Button
        disabled={!btnIsEnabled}
        onClick={() => onUpdateCallback(zipcode)}
        variant="secondary"
        label=""
        style={{ width: '150px', marginLeft: '1rem' }}
      >Update
      </Button>
    </ZipCodeInputWrapper>
  );

};

ZipCodeInput.propTypes = {
  zipcode: PropTypes.string.isRequired,
  onUpdateCallback: PropTypes.func.isRequired,
  onZipcodeChange: PropTypes.func.isRequired,
};

export default ZipCodeInput;